import { Component, ElementRef, ViewChild } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter, take } from "rxjs/operators";
import { ModalRouteService } from "../shared/services/modal-route.service";

@Component({
  selector: "app-modal-container",
  templateUrl: "./modal-container.component.html",
  styleUrls: ["./modal-container.component.scss"],
})
export class ModalContainerComponent {
  @ViewChild("modalContainer", { static: false }) modalContainer: ElementRef;
  show = false;
  constructor(
    private router: Router,
    route: ActivatedRoute,
    private modal: ModalRouteService
  ) {
    router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        take(1)
      )
      .subscribe(() => {
        setTimeout(() => (this.show = true));
      });
  }
}
